const Logout = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 19.2C11 19.7522 11.4477 20.2 12 20.2L17.6 20.2C20.3614 20.2 22.6 17.9614 22.6 15.2L22.6 13.4154C22.6 10.654 20.3615 8.41544 17.6 8.41544L4.79148 8.41544L7.66573 5.50229C8.05363 5.10915 8.04937 4.476 7.65623 4.08811C7.26309 3.70021 6.62994 3.70447 6.24205 4.09761L1.68818 8.7131C1.30397 9.10251 1.30397 9.72837 1.68818 10.1178L6.24205 14.7333C6.62994 15.1264 7.26309 15.1307 7.65623 14.7428C8.04937 14.3549 8.05363 13.7217 7.66573 13.3286L4.79148 10.4154L17.6 10.4154C19.2569 10.4154 20.6 11.7586 20.6 13.4154L20.6 15.2C20.6 16.8568 19.2569 18.2 17.6 18.2L12 18.2C11.4477 18.2 11 18.6477 11 19.2Z"
        fill={color}
      />
    </svg>
  );
  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Logout;
